import ApiClient from '@/api-client';

export default {
    namespaced: true,
    state: {
        membraneRequest: {
            customer: {},
            customerLocation: {},
            requestByUser: {},
        },
        membraneLog: {},
        logValues: [],
    },
    getters: {
        isStatic(state, getters, rootState, rootGetters) {
            return (state.membraneRequest.status === 'Cancelled' || state.membraneRequest.status === 'Completed') || !rootGetters['AuthenticationStore/roles'].includes('membrane_admin');
        },
    },
    mutations: {
        setMembraneRequest(state, membraneRequest) {
            state.membraneRequest = membraneRequest;
        },
        setMembraneLog(state, membraneLog) {
            state.membraneLog = membraneLog;
        },
        setLogValues(state, logValues) {
            state.logValues = logValues;
        },
    },
    actions: {
        async getMembraneRequest({ commit, state }, id) {
            const membraneRequestId = id || state.membraneRequest.id;
            const response = await ApiClient.get(`/api/membrane-requests/${membraneRequestId}?include=log,customer,customerLocation,requestByUser,item.manufacturer`);
            commit('setMembraneRequest', response.data);
            commit('setMembraneLog', response.data.log);
        },
        async getLogValues({ state, commit }) {
            const response = await ApiClient.get(`/api/membrane-requests/${state.membraneRequest.id}/logs/${state.membraneLog.id}/values?include=membrane`);
            commit('setLogValues', response.data.data);
        },
        reset({ commit }) {
            commit('setMembraneRequest', {});
            commit('setMembraneLog', { });
            commit('setLogValues', []);
        },
    },
};
